<template>
  <el-dialog :title="editText + '项目模型'"
             :visible.sync="dialogVisible"
             custom-class="lx-dialog"
             :close-on-click-modal="false"
             @open="handleOpen"
             @close="closeDialog">
    <el-form label-width="120px"
             :rules="rules"
             :model="form"
             ref="form">
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="选择资源"
                        prop="checkedModel">
            <el-radio-group v-model="form.checkedModel">
              <el-radio-button v-for="item of modelResource"
                              :key="item.id"
                              :value="item.value"
                              :label="item.value">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="动画序列号"
                        prop="animateOrder">
            <el-input class="l-d-no-border"
                      v-model="form.animateOrder"
                      placeholder="请输入动画序列号，仅允许输入数字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="small"
                 @click="$emit('update:visible', false)">取 消</el-button>
      <lx-submit btn-size="small"
                 btn-type="primary"
                 :btn-disabled="isBtnDisabled"
                 @click.native="handleSubmitEditResult('form')">确 定</lx-submit>
    </div>
  </el-dialog>
</template>

<script>
import Submitting from '@/components/common/Submitting'
export default {
  props: ['visible', 'max-no', 'apiIndentity', 'row', 'trainProjectItemId'],

  data () {
    let validNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('动画序列号不能为空！'))
      } else if (Number.isInteger(Number(value)) && Number(value) > 999) {
        return callback(new Error('动画序列号不能大于999！'))
      } else {
        let boolean = new RegExp(`^[1-9]\\d*$`).test(value)
        if (!boolean) {
          return callback(new Error('动画序列号只能是正整数！'))
        } else {
          callback()
        }
      }
    }
    return {
      form: { checkedModel: '', animateOrder: '' },
      modelResource: [],
      isBtnDisabled: false,
      rules: {
        checkedModel: [{ required: true, message: '请选择资源', trigger: 'blur' }],
        animateOrder: [{ required: true, validator: validNum, trigger: 'blur' }]
      }
    }
  },

  components: { 'lx-submit': Submitting },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    edit () { return this.row.id },
    editText () { return this.row.id ? '编辑' : '添加' }
  },

  mounted () {
  },

  methods: {
    handleOpen () {
      this.isBtnDisabled = false
      if (this.row.id) {
        this.form.checkedModel = this.row.id
        this.form.animateOrder = this.row.resourceNo
      }
      this.$xhrGet(`/projects/models`)
        .then(rs => {
          this.modelResource = rs.data
        })
    },

    closeDialog () {
      this.form.checkedModel = ''
      this.form.animateOrder = ''
      this.$emit('edit-result', this.form)
      this.$emit('update:visible', false)
    },

    submitProjectModel () {
      // this.form.checkedModel
      let queryParam = {
        trainProjectId: this.trainProjectItemId,
        type: this.row.type,
        resourceNo: this.form.animateOrder
      }
      this.$xhrPost(`/projects/items/models/${this.form.checkedModel}`, queryParam)
        .then(rs => {
          if (rs.code === 200) {
            this.closeDialog()
          }
        })
    },

    handleSubmitEditResult (formName) {
      this.isBtnDisabled = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitProjectModel()
        } else {
          this.$message.error('请检查输入')
          this.isBtnDisabled = false
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/teaching/ModelEditor.vue